import Container from 'react-bootstrap/Container'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'

function Footer({socials}) {
    // Instagram configuration
    const instagramLogo = "https://sqlvas774pizbiy4km.blob.core.windows.net/liveenvironment/website/mila/elements/instagram icon.png";
    const instagramLink = "https://www.instagram.com/milabysmoky/?hl=en";
    
    // WhatsApp and Call images (you'll need to provide these URLs)
    const whatsappImage = "https://sqlvas774pizbiy4km.blob.core.windows.net/liveenvironment/website/mila/elements/whatsapp.png";
    const callImage = "https://sqlvas774pizbiy4km.blob.core.windows.net/liveenvironment/website/mila/elements/call.png";

    return (
        <div style={{ 
            backgroundColor: '#f0e7da',
            padding: '40px 0'
        }}>
            <Container className="py-4">
                <Row className="align-items-center">
                    {/* Logo on left - SAME SIZE AS HEADER */}
                    <Col xs={4} md={4} className="text-start">
                        <img
                            src="https://sqlvas774pizbiy4km.blob.core.windows.net/liveenvironment/website/mila/elements/Mila logo.png"
                            className="footer-logo img-fluid"
                            alt="Mila Logo"
                            style={{ 
                                maxHeight: '40px', // Same as header logo
                                height: 'auto',
                                width: 'auto'
                            }}
                        />
                    </Col>
                    
                    {/* Text content center */}
                    <Col xs={12} md={4} className="text-center order-md-2 order-3 mt-3 mt-md-0">
                        <div>
                            <p className="headers-font primary fs-7 mb-1" style={{ 
                                fontSize: '0.9rem',
                                fontWeight: 'bold'
                            }}>
                                Opening Hours from 09:00AM to 02:00AM
                            </p>
                            
                            <p className="headers-font primary fs-6" style={{ 
                                fontSize: '1rem',
                                fontWeight: 'normal'
                            }}>
                                PALM JUMEIRAH, WEST BEACH DUBAI
                            </p>
                        </div>
                    </Col>
                    
                    {/* Instagram on right */}
                    <Col xs={8} md={4} className="text-end order-md-3 order-2">
                        <div className="d-flex justify-content-end align-items-center">
                            <div className="me-2 me-md-3">
                                <p className="headers-font primary m-0" style={{ fontSize: '0.9rem' }}>
                                    @MILABYSMOKY
                                </p>
                            </div>
                            <div>
                                <a 
                                    href={instagramLink} 
                                    target="_blank" 
                                    rel="noopener noreferrer"
                                    className="d-inline-block"
                                >
                                    <img 
                                        src={instagramLogo} 
                                        alt="Instagram"
                                        style={{ 
                                            width: '20px', 
                                            height: '20px',
                                            verticalAlign: 'middle'
                                        }}
                                    />
                                </a>
                            </div>
                        </div>
                    </Col>
                </Row>
            </Container>
        </div>
    );
}

export default Footer;